export default (state: { current: bb.state.ICurrent }) => state.current;